import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { fetchRecuperarCarritoAccP } from '../../redux/actions/aRamoAccidentesPersonales';
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import CotizacionAccPersonalVigencia from '../../components/CotizacionAccidentePersonal/CotizacionAccPersonalVigencia';

const ContainerCotizacionAccPersonalVigencia = (props) => {

    const dispatch = useDispatch();
    const [idCarrito, setIdCarrito] = useState(null)
    const [dataPlan, setDataPlan] = useState(null)
    const [fechaInicio, setFechaInicio] = useState(new Date())
    const [fechaFin, setFechaFin] = useState(new Date())

    const datosRecuperarCarritoAccP = useSelector(state => state.datosRecuperarCarritoAccP);
    const datosCarritoAccP = useSelector(state => state.datosCarritoAccP);
    const [datosRecuperados, setDatosRecuperados] = useState(false)





    useEffect(() => {

        const queryParams = new URLSearchParams(props.location.search);
        const idCarrito = queryParams.get("id") || queryParams.get("idCarrito");

        let idActual = ''

        if (idCarrito !== undefined && idCarrito !== null && idCarrito !== "") {
            idActual = idCarrito
        } else {
            idActual = datosCarritoAccP.productoAccP.idCarrito
        }

        setIdCarrito(idActual)

        dispatch(fetchRecuperarCarritoAccP({ empresa: "AIGMETROPOLITANA", idCarrito: idActual }));

    }, []);

    useEffect(() => {
        if (datosRecuperarCarritoAccP && datosRecuperarCarritoAccP.recuperarCarritoAccP) {
            if (datosRecuperarCarritoAccP.recuperarCarritoAccP.carFechaEmisionRetroactivaFutura) {
                setFechaInicio(datosRecuperarCarritoAccP.recuperarCarritoAccP.carFechaEmisionRetroactivaFutura);
                setDatosRecuperados(true);
            }
            if (datosRecuperarCarritoAccP.recuperarCarritoAccP.carFechaEmisionRetroactivaFuturaFin) {
                setFechaFin(datosRecuperarCarritoAccP.recuperarCarritoAccP.carFechaEmisionRetroactivaFuturaFin);
            }
            if (datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos && datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos.length > 0) {
                setDataPlan(datosRecuperarCarritoAccP.recuperarCarritoAccP.carProductos[0]);
            }
        }
    }, [datosRecuperarCarritoAccP]);


    const onClickRegresar = () => {
        props.history.push({
            pathname: `/servicios-cotizacion-accidente-personal`,
            search: "?id=" + idCarrito,
        });

        window.location.reload();
    }
    const onClickSiguiente = () => {
        props.history.push({
            pathname: "/detalle-cotizacion-accidente-personal",
            search: "?idCarrito=" + idCarrito,
        });
        window.location.reload();
    };

    return (
        <LoadingScreen
            loading={
                datosRecuperarCarritoAccP.recuperarCarritoAccPIsLoading
            }
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando datos..."
        >

            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        {(idCarrito && dataPlan) &&
                            <CotizacionAccPersonalVigencia
                                idCarrito={idCarrito}
                                dataPlan={dataPlan}
                                onRegresar={() => { onClickRegresar() }}
                                onSiguiente={() => { onClickSiguiente() }}
                                datosRecuperados={datosRecuperados}
                                fechaInicio={fechaInicio}
                                fechaFin={fechaFin}

                            />
                        }

                    </div>
                </div>
            </main>



        </LoadingScreen>
    )

}



export default ContainerCotizacionAccPersonalVigencia;
